import { cva } from 'class-variance-authority';

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: {
      large: 'text-size-headline-3xl ml-[0.7rem]',
      normal: 'text-size-headline-xl ml-[0.6rem]',
      small: 'text-size-headline-base ml-1',
    },
  },
  defaultVariants: { size: 'normal' },
});
